import React, { Component } from 'react';
import { Col, Row, Alert, Spinner } from "react-bootstrap";
import Modal from 'react-modal';
import { connect } from 'react-redux';
import moment from 'moment';
import { createNotification } from '../notifications/notifications';
import { notificationsLibrary } from '../../utils/notificationsLibrary.js';
import BookRequestTable from '../BookRequestTable/BookRequestTable';
import ModalForm from './ModalForm';
import ModalTable from './ModalTable';
import BookRequestFilter from '../BookRequestTable/BookRequestFilter';
import CreateNewForm from './CreateNewForm';


const mapStateToProps = ({ form }) => ({
  timeValues: form.bookRequestFilterOrder
});

class NewBookRequest extends Component {

  state = {
    tableLoading: true,
    tableError: false,
    modalVisible: false,
    creationModal: false,
    requestId: null,
  };

  componentDidMount() {
    setTimeout(this.selectOrders, 100);
  };

  selectOrders = () => {
    let from = moment(this.props.timeValues.values.selectFrom).format("YYYY-MM-DD");
    let to = moment(this.props.timeValues.values.selectTo).format("YYYY-MM-DD");
    this.props.newBookRequestList([from, to])
      .then(() => {
        this.setState({tableLoading: false});
        if(this.props.newBookOrdersList.status === 404 ) {
          this.setState({tableError: true});
          createNotification('error', notificationsLibrary['05']);
        }
      });
  };

  addNewRequest = (formData) => {
    const requestValues = {
      "curriculum_course_id": formData.curriculum_course_id,
      "cathedra": formData.cathedra
    };

    this.props.addBookRequest(requestValues)
      .then(() => {
        this.handleCreationModal(false);
        this.handleEditModal(true, this.props.addNewOrderData.id);
        createNotification('success', notificationsLibrary['11']);
      })
      .catch(() => {
        createNotification('error', notificationsLibrary['10']);
      });
  };

  deleteRequest = (requestId) => {
    const confirm = window.confirm('Вы действительно хотите удалить заказ?');

    if(confirm) {
      this.props.deleteBookRequest(requestId)
        .then(() => {
          this.handleEditModal(false);
          createNotification('success', notificationsLibrary['08']);
        })
        .catch(() => {
          createNotification('error', notificationsLibrary['07']);
        });
    }
  };

  handleSubmit = (values) => {
    let from = moment(values.selectFrom).format("YYYY-MM-DD");
    let to = moment(values.selectTo).format("YYYY-MM-DD");
    this.props.newBookRequestList([from, to]);
  };

  handleEditModal = (modalVisible, id) => {
    this.setState({modalVisible: modalVisible});
    if(modalVisible === false) {
      this.componentDidMount();
      return;
    }
   this.props.newBookRequestId(id)
  };

  handleCreationModal = (modalVisible) => {
    this.setState({creationModal: modalVisible});
  };

  render() {
    const { tableLoading, tableError, modalVisible, creationModal } = this.state;
    const { newBookOrdersList, bookOrderIdData, addNewBookToOrder, editNewBook, deleteNewBook } = this.props;

    return (
      <div>
        <div className="captions">Заказ на поставку литературы</div>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <BookRequestFilter formName='Order' onSubmit={this.handleSubmit}/>
          <button className="btn" onClick={() => this.handleCreationModal(true)} >Добавить новый</button>
        </div>
        <Modal
          isOpen={creationModal}
          className="StudentProjectSmallModal"
          onRequestClose={() => this.handleCreationModal(false)}
          contentLabel="Modal"
        >
          <CreateNewForm modalHandler={this.handleCreationModal} submitHandler={this.addNewRequest}/>
        </Modal>
        <Modal
          isOpen={modalVisible}
          onRequestClose={() => this.handleEditModal(false)}
          contentLabel="Modal"
        >
          <ModalTable modalData={bookOrderIdData} editBook={editNewBook} deleteBook={deleteNewBook} />
          <ModalForm modalData={bookOrderIdData} addNewBookToOrder={addNewBookToOrder} modalHandler={this.handleEditModal} deleteRequest={this.deleteRequest}/>
        </Modal>
        <Row>
          {tableLoading ? (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="sr-only">Загрузка...</span>
              </Spinner>
            </div>
          ) : (
            <Col md={12}>
              {tableError ? (
                  <Alert variant="danger">
                    <Alert.Heading>Не удалось загрузить данные!</Alert.Heading>
                  </Alert>
              ) : (
                <div>
                  {newBookOrdersList.length ? (
                    <BookRequestTable data={newBookOrdersList} modalHandler={this.handleEditModal} />
                  ) : (
                    <Alert variant="danger">
                      <Alert.Heading>Ничего не найдено</Alert.Heading>
                    </Alert>
                  )}
                </div>
              )}
            </Col>
          )}
        </Row>
      </div>
    )
  }
}

export default connect(mapStateToProps)(NewBookRequest);

